import { useQuery } from '@tanstack/react-query';

interface InvitationUrlResponse {
  invitation_url: string;
}

export default function useFetchInvitationUrl(agentId: number | null) {
  return useQuery({
    queryKey: ['alliance-agent-invitation-url', agentId],
    queryFn: async () => {
      const response = await fetch(`/agent/api/alliance_agents/${agentId}/invitation_url`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      });

      if (!response.ok) {
        let errorMessage = '招待URLの取得に失敗しました';
        try {
          const errorData: { error?: string; errors?: string[] } = await response.json();
          errorMessage = errorData.errors?.[0] || errorData.error || errorMessage;
        } catch {
          // JSONパースに失敗した場合はデフォルトメッセージを使用
        }
        throw new Error(errorMessage);
      }

      const data: InvitationUrlResponse = await response.json();
      return data;
    },
    enabled: agentId !== null,
  });
}
